<template>
  <div id="alert-display" v-if="alertType">
    <div class="notification" :class="alertClass[alertType]">
      <strong>{{ alertMessage }}</strong>
    </div>
  </div>
<!-- #alert-display(v-if="alertType")
  .notification(
    :class="alertClass[alertType]"
    )
    button.delete(@click="clearAlert")
    h2.subtitle.has-text-black
      strong {{ alertMessage }}
    .progressbar(:style="{width:alertProgress + '%'}") -->
</template>

<script>
  export default {
    data() {
      return {
        alertClass: {
          error: 'is-danger',
          success: 'is-success'
        }
      }
    },
    computed: {
      alertType() {
        return this.$store.getters['alert/type']
      },
      alertMessage() {
        return this.$store.getters['alert/message']
      },
      alertProgress() {
        return this.$store.getters['alert/progress']
      }
    },
    methods: {
      clearAlert() {
        this.$store.dispatch('alert/ALERT_CLEAR')
      }
    }
  }
</script>

<style>
  #alert-display {
    position: fixed;
    top: 60px;
    right: 20px;
    z-index: 100;
    animation: alert-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);
  }

  #alert-display .notification {
    margin:0;
    border-radius: 12px;
    padding: 16px 22px;
    box-shadow: 0 8px 28px rgba(27, 42, 50, 0.18);
  }

  @keyframes alert-slide-in {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

</style>
